import { usePlaces } from '@/hooks/usePlaces';
import { PlaceCard } from '@/components/PlaceCard';
import { useFavorites } from '@/hooks/useFavorites';
import { EmergencyIcon } from '@/components/Icons';

const SECTIONS: { subcategory: string; title: string; blurb: string }[] = [
  { subcategory: 'emergency', title: 'Emergency Departments', blurb: 'For chest pain, stroke symptoms, severe injury, or anything life-threatening — call 911.' },
  { subcategory: 'urgent_care', title: 'Urgent Care', blurb: 'For sprains, minor cuts, fevers, and illness that needs same-day care but isn’t life-threatening.' },
  { subcategory: 'primary_care', title: 'Primary Care', blurb: 'Routine checkups, prescriptions, and ongoing care.' },
  { subcategory: 'specialist', title: 'Specialists', blurb: 'Verified specialist referrals used by the family.' },
  { subcategory: 'dental', title: 'Dental', blurb: 'Routine and emergency dental care.' },
  { subcategory: 'pharmacy', title: 'Pharmacy', blurb: 'Prescription pickup and everyday pharmacy needs.' },
  { subcategory: 'lab_imaging', title: 'Lab / Imaging', blurb: 'Bloodwork, X-ray, and imaging orders.' },
];

export function MedicalPage() {
  const { places, loading } = usePlaces('medical');
  const { isFavorite, toggle } = useFavorites();

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Medical</h1>
        <p className="page-subtitle">Know where to go before you need to</p>
      </div>

      <div className="card" style={{ background: 'var(--color-alert-bg)' }}>
        <h2 style={{ color: 'var(--color-alert)', display: 'flex', alignItems: 'center', gap: 6 }}>
          <EmergencyIcon />
          True Emergency
        </h2>
        <p style={{ fontSize: 14, marginBottom: 12 }}>Life-threatening emergency? Call 911 immediately.</p>
        <a href="tel:911" className="btn btn-danger btn-block">
          Call 911
        </a>
      </div>

      {loading && <div className="skeleton" style={{ height: 140 }} />}

      {!loading &&
        SECTIONS.map(({ subcategory, title, blurb }) => {
          const items = (places ?? []).filter((p) => p.subcategory === subcategory);
          if (items.length === 0) return null;
          return (
            <section key={subcategory} style={{ marginBottom: 8 }}>
              <div className="section-title">{title}</div>
              <p style={{ fontSize: 13, color: 'var(--color-ink-muted)', marginBottom: 8 }}>{blurb}</p>
              {items.map((p) => (
                <PlaceCard key={p.id} place={p} detailed isFavorite={isFavorite(p.id)} onToggleFavorite={toggle} />
              ))}
            </section>
          );
        })}
    </div>
  );
}
